import { IGatsbyImageData } from 'gatsby-plugin-image'
import { AllFileQueryI } from '../types/common'

const DUMMY_GATSBY_IMAGE = {
  layout: 'constrained',
  placeholder: {
    fallback:
      'data:image/jpeg;base64,/9j/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAgJBv/EABYBAQEBAAAAAAAAAAAAAAAAAAUEBv/aAAwDAQACEAMQAAABXhkJQ6d/H2AJLErX/8QAGhAAAgMBAQAAAAAAAAAAAAAABAYDBQcCEf/aAAgBAQABBQJeQae36rMaENh5wwbwdsPFgV9CvFAQrRng2T//xAAiEQADAAEDAwUAAAAAAAAAAAABAgMRBAYSAAUiExQhMbH/2gAIAQMBAT8BnsHZtqI2q7x3UsUqzm/u+M7Bk9KdJ6dnBW3kwaRoFwBQLyPFNr7YVVUFcKABmV8/GPvxP6ev/8QAIxEAAgEBBwUAAAAAAAAAAAAAAQIDEQAEBQYSEyEiMUFS0f/aAAgBAgEBPwF8y5iRGENwulA0YTbaHrjNdxkaXboY+AQ4TVzoLeTjWNEknR39l+W//8QAKBAAAgIBAwMBCQAAAAAAAAAAAgMBEQQABRITMWEGISIjJDJBQqGx/9oACAEBAAY/Alqx982snTET0ScKmT2vj1eIHV9gKZ8aU/GzsHMS6LS3FeloNG6tZgcicXExMjft1FjH9/caejKZl5o5IdNfz7cSETxMTLigfjcxOqP6ePulFlZbft+XuCwMyNTMPc8jbyRLBgToVQaj5TxKeQfj5vUOyfVnqQ2cBDkG9ZibgO1iowG/NXP31//EABoQAQEBAQEBAQAAAAAAAAAAAAERACExQcH/2gAIAQEAAT8hjGWt56SEKG9Y7pKXTYopCAAEYjumbOpfyaEL6KzaGbwqLJY3CH/Rrw1AWIqwUteGqEs9t+dTN//aAAwDAQACAAMAAAAQ9x//xAAZEQEBAQADAAAAAAAAAAAAAAABESEAMWH/2gAIAQMBAT8QmuIwKFXUvqGHCfyZWAfRjexut3//xAAZEQEBAQADAAAAAAAAAAAAAAABESEAMUH/2gAIAQIBAT8QcLIqyQhXs5UAHkyCqUHDTrDMzBzxk//EABkQAQEBAQEBAAAAAAAAAAAAAAERACExQf/aAAgBAQABPxA9740E4MX2OAof+NnS4qEgXsS5sgDpREBI0SU8cSlZfXpkqfMzqIAhpX+1iU6c/dEKHmz4c64d/9k=',
  },
  images: {
    fallback: {
      src: '/static/92c802831bbc6a128d4c38f73994ee9a/95506/t10-sm.jpg',
      srcSet:
        '/static/92c802831bbc6a128d4c38f73994ee9a/440ea/t10-sm.jpg 120w,\n/static/92c802831bbc6a128d4c38f73994ee9a/e92a3/t10-sm.jpg 240w,\n/static/92c802831bbc6a128d4c38f73994ee9a/95506/t10-sm.jpg 480w',
      sizes: '(min-width: 480px) 480px, 100vw',
    },
    sources: [
      {
        srcSet:
          '/static/92c802831bbc6a128d4c38f73994ee9a/cbc71/t10-sm.webp 120w,\n/static/92c802831bbc6a128d4c38f73994ee9a/a6986/t10-sm.webp 240w,\n/static/92c802831bbc6a128d4c38f73994ee9a/b2c38/t10-sm.webp 480w',
        type: 'image/webp',
        sizes: '(min-width: 480px) 480px, 100vw',
      },
    ],
  },
  width: 480,
  height: 320,
} as IGatsbyImageData

export const getGatsbyImage = (imgURL: string, allImages: AllFileQueryI): IGatsbyImageData => {
  const foundImage = allImages.edges.find((item) => imgURL.includes(item.node.relativePath))
  return foundImage ? foundImage.node.childImageSharp.gatsbyImageData : DUMMY_GATSBY_IMAGE
}
